export function tryClick(element, parameters) {
  window.setTimeout( (elem, params) => {
    if (params.count < params.max) {
      if (elem.disabled) {
        params.count++;
        tryClick(elem, params);
      } else {
        elem.click();
      }
    } else {
      console.error('tryClick: failed to click. Maximum number of attempts exceeded.');
    }
  }, parameters.interval, element, parameters);
}